<template>
<div>
	<div class="home_head">
		<div class="head_top">
			<div class="head_content">
				<div class="title">
					<img src="../../assets/images/logo.png" alt="">
					中缅跨境劳务服务中心办事大厅
				</div>
				<div class="menuList">
					<div v-for="(item,index) in menuList"  :key="index" @click="link(item,index)" :class="['menu',{active:$route.meta.activeMenu==item.url}]">
						<span>{{item.name}}</span>
					</div>
				</div>				
			</div>
		</div>
	</div>
	<div class="rightIcon">
		<div class="service btn">
			<p>联系客服</p>
			<div class="dialog">
				<div class="arr"></div>
				<img :src="kefuInfo.kf_qrcode" alt="">
				<p>扫描咨询</p>
			</div>
		</div>
		<div class="tele btn">
			<p>电话咨询</p>
			<div class="dialog dia_tele">
				<div class="arr"></div>
				热线电话：{{kefuInfo.home_tel}}
			</div>			
		</div>
		<div class="report btn" @click="reportDialog"><p>举报</p></div>
	</div>
	<el-dialog
		:visible.sync="dialogVisible"
		width="500px" class="zxDialog">
		<div class="one">
			<div class="left">
				<p>咨询方式一：</p>
				<p>扫码咨询</p>
			</div>
			<img class="right" :src="codeUrl" width="120px" height="120px">
		</div>
		<div class="two">
			<div class="left">
				<p>咨询方式二：</p>
				<p>电话咨询</p>
			</div>
			<div class="right">
				<p>0591-4510000</p>
			</div>
		</div>
	</el-dialog>
	<el-dialog
		title="举报"
		:visible.sync="dialogFormVisible"
		width="800px" class="zxDialog">
		<div class="repore_content">
			<el-form ref="form" :model="form" :rules="rules" label-width="120px">
				<el-form-item label="举报类型" prop="type" class="sw480">
					<el-select v-model="form.type" placeholder="请选择举报类型">
						<el-option label="违法举报" value="1"></el-option>
						<el-option label="违规举报" value="2"></el-option>
						<el-option label="其他" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="举报内容" prop="content">
					<el-input type="textarea" :rows="3" v-model="form.content" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="举报方式" prop="checked">
					<el-checkbox v-model="form.checked">匿名</el-checkbox>
				</el-form-item>
				<el-form-item label="举报人" prop="informer" :rules="form.checked ? [{ required: false }] : rules.informer">
					<el-input v-model="form.informer" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="联系方式" prop="contacts">
					<el-input v-model="form.contacts" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="图片验证码" prop="captcha_code">
					<div class="view-captcha">
					<div class="captcha-value">
						<el-input
						class="codeipt"
						v-model="form.captcha_code"
						></el-input>
					</div>
					<div class="divIdentifyingCode" @click="getIdentifyingCode()">
						<img
						id="imgIdentifyingCode"
						style="height: 40px; width: 100px; cursor: pointer"
						src=""
						alt="点击更换"
						title="点击更换"
						/>
					</div>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="resetForm">取 消</el-button>
			<el-button type="primary" @click="submit">提 交</el-button>
		</div>
	</el-dialog>
</div>
</template>

<script>
	import wxcodeUrl from '../../assets/images/wx.png'
	import api from "@/request/api"

	export default {
		data() {
			return {
				menuList:[{
					name:'首页',
					url:'/'
				},{
					name:'招聘公告',
					url:'/recruitment'
				},{
					name:'学习中心',
					url:'/study'
				}],
				dialogVisible: false,
				codeUrl:wxcodeUrl,
				dialogFormVisible:false,
				form:{
					type: '',
					content: '',
					checked: false,
					informer: '',
					contacts: '',
					captcha_code:'',
					captcha_key:''
				},
				rules:{
					type: [
						{ required: true, message: '请选择举报类型', trigger: 'change' }
					],
					content: [
						{ required: true, message: '请输入举报内容', trigger: 'blur' }
					],
					informer: [
						{ required: true, message: '请输入举报人', trigger: 'blur' }
					],
					contacts: [
						{ required: true, message: '请输入联系方式', trigger: 'blur' }
					],
					captcha_code: [
						{ required: true, message: '请输入图片验证码', trigger: 'blur' }
					]
				},
				kefuInfo: {}
			}
		},
		created(){
			this.getKeFuInfo();
		},
		methods: {
			getKeFuInfo () {
				this.$axios.get(api.baseImgUrl,{set_id: 'h5_qrcode,kf_qrcode,home_tel'}).then((res) => {
					this.kefuInfo = res.result.data;
					window.sessionStorage.setItem('h5_qrcode', this.kefuInfo.h5_qrcode);
				});
			},
			link(item,index){
				this.$router.push(item.url)
			},
			reportDialog(){
				this.getIdentifyingCode()
				this.dialogFormVisible=true
			},
			getIdentifyingCode() {
				const self = this;
				self.$axios.get(api.getcaptcha).then((res) => {
					const { result } = res || {};
					self.form.captcha_key = result.key;
					let identifyCodeSrc = result.img;
					let objs = document.getElementById("imgIdentifyingCode");
					objs.src = identifyCodeSrc;
				});
			},
			submit(){
				this.$refs['form'].validate((valid) => {
					if (valid) {
						const self = this;
						if(self.form.checked){
							self.form.informer='匿名'
						}
						self.$axios.post(api.addinform,self.form).then((res) => {
							this.dialogFormVisible=false
							this.$refs['form'].resetFields();
						});
						
					} else {
						console.log('error submit!!');
						return false;
					}
				});
				
			},
			resetForm(){
				this.$refs['form'].resetFields();
				this.dialogFormVisible=false
			}
		}
	}
</script>
<style>
.sw480 .el-input {
	width: 480px;
}
</style>
<style lang="less" scoped>
	.page-head{
		width: 100%;
		height: 150px;
		background-image: url(../../assets/images/top.jpg);
		background-size: 100% 100%;
		.title{
			width: 1280px;
			line-height: 100px;
			font-size: 30px;
			font-weight: bold;
			color: #409EFF;
			padding-left: 60px;
			margin: 0 auto;
			display: block;
		}
		.content{
			width: 100%;
			height: 60px;
			line-height: 60px;
			background-color: #4888CD;
			margin-top: -10px;
			overflow: hidden;
			.menuList{
				width: 1280px;
				height: 60px;
				margin: 0 auto;
				.menu{
					width: 200px;
					text-align: center;
					font-size: 24px;
					font-weight: bold;
					color: #fff;
					float: left;
					cursor: pointer;
				} 
				.active{
					background-color: #409EFF;
				}
			}
		}
		
	}
	.home_head {
		width: 100%;
		height: 355px;
		background: url('../../assets/images/home_banner.jpg') center no-repeat;
		background-size: 100% 100%;
		.head_top {
			width: 100%;
			height: 60px;
			background: rgba(255, 255, 255, 0.18);
			.head_content {
				width: 1280px;
				margin: 0 auto;
				display: flex;
				justify-content: space-between;
				.title {
					font-size: 30px;
					font-weight: 700;
					line-height: 60px;
					color: #fff;
					img {
						width: 36px;
						height: auto;
						vertical-align: middle;
					}
				}
				.menuList{
					.menu{
						padding: 0 20px;
						text-align: center;
						font-size: 20px;
						font-weight: bold;
						color: #fff;
						float: left;
						line-height: 54px;
						cursor: pointer;
						margin-right: 50px;
					} 
					.active{
						border-bottom: 6px solid #fff;
					}
				}
			}
		}
	}
	.rightIcon{
		width: 60px;
		position: fixed;
		top: 50%;
		right: 30px;
		transform: translateY(-50%);
		z-index: 999;
		background: #FFFFFF;
		box-shadow: 0px 0px 5px 0px rgba(48, 48, 48, 0.19);
		border-radius: 5px;		
		// overflow: hidden;
		.btn{
			width: 60px;
			height: 80px;
			cursor: pointer;
			background-image: url('../../assets/images/kf_1.png');
			background-size: 24px 24px;
			background-repeat: no-repeat;
			background-position: 18px 20px;
			position: relative;
			&.service:hover {
				background-color: #257ED7;
				background-image: url('../../assets/images/kf_2.png');
				p {
					color: #fff;
				}
				.dialog {
					display: block;
				}
			}
			&.tele {
				background-image: url('../../assets/images/tele_1.png');
				&:hover {
					background-color: #257ED7;
					background-image: url('../../assets/images/tele_2.png');
					p {
						color: #fff;
					}
					.dialog {
						display: block;
					}
				}
			}
			&.report {
				background-image: url('../../assets/images/report_1.png');
				&:hover {
					background-color: #257ED7;
					background-image: url('../../assets/images/report_2.png');
					p {
						color: #fff;
					}					
				}
			}
			p {
				padding-top: 50px;
				text-align: center;
			}
			.dialog {
				position: absolute;
				right: 120%;
				top: -50%;
				color: #fff;
				padding: 15px 18px 10px;
				background-color: #257ED7;
				border-radius: 5px;
				display: none;
				&.dia_tele {
					white-space: nowrap;
					top: 20px;
					font-size: 16px;
					padding: 6px 12px;
				}
				img {
					display: inline-block;
					width: 89px;
					height: 89px;
				}
				p {
					margin-top: 10px;
					padding-top: 0;
				}
				.arr {
					width: 0;
					height: 0;
					border-top: 10px solid transparent;
					border-left: 15px solid #257ED7;
					border-bottom: 10px solid transparent;
					position: absolute;
					right: -10px;
					top: 50%;
					margin-top: -7px;
				}
			}
		}
	}
	.zxDialog{
		.repore_content {
			padding: 0 80px;
		}
		.one,.two{
			// height: 110px;
			line-height: 26px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin: 0 25px;
			font-size: 16px;
			img{
				margin: 0 35px;
			}
		}
		.one{
			padding-bottom: 50px;
			border-bottom: 1px solid #efefef;
		}
		.two{
			margin: 50px 25px;
			padding-right: 15px;
			.right{
				font-size: 26px;
				font-weight: bolder;
				color: #FF9C00;
			}
		}
	}
	.view-captcha {
        display: flex;
        .captcha-value {
          width: 120px;
        }
        .captcha-label {
          width: 100px;
          height: 40px;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
		}
		.divIdentifyingCode{
			margin-left: 15px;
		}
	}
	.w100 {
		.el-input {
			width: 100%;
		}
	}
</style>
